import React from "react";
import { Commons } from "../utilities";
import { Navigate } from "react-router-dom";
// import { useAlert } from "../contexts";

const PrivateRoute = ({ element: Element, userType, isVerified }) => {
    // const { showAlert } = useAlert();
    const patient_access = JSON.parse(localStorage.getItem("patient_access"));
    const isPatientLoggedIn = patient_access?.token;


    const doctor_access = JSON.parse(localStorage.getItem("doctor_access"));
    const isDoctorLoggedIn = doctor_access?.token;
    const isDoctorVerified = doctor_access?.isVerified;


    const admin_access = JSON.parse(localStorage.getItem("admin_access"));
    const isAdminLoggedIn = admin_access?.token;




    if (userType === Commons.userType.patient && !isPatientLoggedIn) {
        return <Navigate to="/patient/login" />;
    }
    if (userType === Commons.userType.doctor && !isDoctorLoggedIn) {
        return <Navigate to="/doctor/login" />;
    }

    if (userType === Commons.userType.doctor) {
        if (!isDoctorLoggedIn) {
            return <Navigate to="/doctor/login" />;
        }
        if (isVerified && !isDoctorVerified) {
            return <Navigate to="/doctor/my-profile/personal-information" />;
        }

    }

    if (userType === Commons.userType.admin && !isAdminLoggedIn) {
        return <Navigate to="/admin/login" />;
    }

    const loginData =
        userType === Commons.userType.patient
            ? patient_access
            : userType === Commons.userType.doctor
                ? doctor_access
                : userType === Commons.userType.admin
                    ? admin_access
                    : null;

    return <Element loginData={loginData} />;
};

export default PrivateRoute;
